"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _googleLibphonenumber = require("google-libphonenumber");

exports.default = {
  getExampleNumberForType: function getExampleNumberForType(countryCode) {
    var device = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _googleLibphonenumber.PhoneNumberType.FIXED_LINE_OR_MOBILE;

    var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();

    try {
      var phoneExampleArr = phoneUtil.getExampleNumberForType(countryCode, device).values_[2].toString();
      return this.displayPhone(phoneExampleArr, countryCode);
    } catch (e) {
      return null;
    }
  },
  getExampleNumber: function getExampleNumber(countryCode) {
    var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();
    try {
      var phoneExampleArr = phoneUtil.getExampleNumber(countryCode) && phoneUtil.getExampleNumber(countryCode).values_[2].toString();
      return this.displayPhone(phoneExampleArr, countryCode);
    } catch (e) {
      return null;
    }
  },
  validatePhone: function validatePhone(str, countryCode) {
    var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();
    try {
      var number = phoneUtil.parseAndKeepRawInput(str, countryCode);
      if (!phoneUtil.isValidNumber(number, countryCode)) {
        return null;
      }
      var e164 = phoneUtil.format(number, _googleLibphonenumber.PhoneNumberFormat.E164);
      var extension = number.getExtension();
      if (extension) {
        e164 += ";ext=" + extension;
      }
      return e164;
    } catch (e) {
      return null;
    }
  },
  displayPhone: function displayPhone(phone, countryCode) {
    var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();
    try {
      var number = phoneUtil.parseAndKeepRawInput(phone, countryCode);
      var displayed = phoneUtil.format(number, countryCode === phoneUtil.getRegionCodeForNumber(number) ? _googleLibphonenumber.PhoneNumberFormat.NATIONAL : _googleLibphonenumber.PhoneNumberFormat.INTERNATIONAL);
      return displayed.replace(" ", "-");
    } catch (e) {
      return null;
    }
  },
  internationalizePhone: function internationalizePhone(phone, countryCode) {
    var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();
    try {
      var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();
      var number = phoneUtil.parseAndKeepRawInput(phone, countryCode);
      return phoneUtil.format(number, _googleLibphonenumber.PhoneNumberFormat.E164);
    } catch (e) {
      return null;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/PhoneUtils.js
// module id = 267
// module chunks = 0